import React from "react";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import { Button } from "reactstrap";
const StatusSelect = (props) => {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      animation={false}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ marginBottom: 15 }}>
          <Select
            closeMenuOnSelect={true}
            isMulti
            placeholder="Status"
            onChange={props.handleChange}
            options={props.options}
            value={props.selectedOption}
          />
        </div>
        {props.showChannelFilter ? (
          <div style={{ marginBottom: 15 }}>
            <Select
              closeMenuOnSelect={true}
              placeholder="Channel"
              onChange={props.handleChannelChange}
              options={props.channelOptions}
              value={props.selectedChannelOption}
            />
          </div>
        ) : (
          ""
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={props.onHide}>
          Cancel
        </Button>
        <Button variant="primary" color="primary" onClick={props.statusFilter}>
          Save{" "}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default StatusSelect;
